var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLetter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37587 1.74338C2.13813 0.879736 3.25606 0.333008 4.50065 0.333008H12.834C13.8901 0.333008 14.8563 0.727042 15.5903 1.37489C16.4539 2.13716 17.0007 3.25509 17.0007 4.49967V9.49967C17.0007 11.8009 15.1352 13.6663 12.834 13.6663H4.50065C2.19946 13.6663 0.333984 11.8009 0.333984 9.49967V4.49967C0.333984 3.44353 0.728018 2.47739 1.37587 1.74338ZM3.31108 2.30007L8.64071 6.72753L13.6545 2.13722C13.3977 2.04805 13.1217 1.99967 12.834 1.99967H4.50065C4.06992 1.99967 3.6649 2.10826 3.31108 2.30007ZM14.9672 3.19509L9.23004 8.44765C8.92285 8.7289 8.45518 8.74015 8.13482 8.47401L2.19231 3.53741C2.06876 3.83343 2.00065 4.15831 2.00065 4.49967V9.49967C2.00065 10.8804 3.11994 11.9997 4.50065 11.9997H12.834C14.2147 11.9997 15.334 10.8804 15.334 9.49967V4.49967C15.334 4.0215 15.2002 3.575 14.9672 3.19509Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLetter);
export default __webpack_public_path__ + "static/media/icon_letter.1dd194a5ec8cc814abbad2697df1e1f0.svg";
export { ForwardRef as ReactComponent };